import { makeStyles } from "@material-ui/styles";

const useStyle = makeStyles((theme) => ({
  container: {
    "@media (max-width: 820px)": {
      flexWrap: "wrap !important",
    },
  },
  actionContainer: {
    color: theme.props.background,
    margin: -4,
    width: "max-content",
    "& button": {
      margin: 4,
    },
  },
}));

export default useStyle;
